<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-top:150px;">About the Author</h1>
<br/><br/>
<p>Rev. James Pike is pastor of Lutheran Church of the Resurrection in Huntington Beach, California. He received his M.Div. from Trinity Lutheran Seminary in Columbus, Ohio. He also works with non-profits helping victims of violence and those with developmental disabilities. For over a decade he performed live sketch, improv and stand-up comedy in Los Angeles.</p>
<br/>
<p>Prof. Robert J. Valenza is the Dengler-Dykema Professor of Mathematics and the Humanities at Claremont McKenna College in Claremont, California. He received his doctorate in mathematics from Columbia University and has published works in pure and applied mathematics, stylometry and philosophy (including metaphysics, aesthetics and the philosophy of science).</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?39fa2377